import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import CasesAnalytics from './CasesAnalytics';
import ProfessionalsAnalytics from './ProfessionalsAnalytics';
import ProfessionalUserAnalytics from './ProfessionalUserAnalytics';
import UserLoginActivity from './UserLoginActivity';
import ClientUserAnalytics from './ClientUserAnalytics';
import AllCaseList from './AllCaseList';
import ClientAnalytics from './ClientAnalytics';
import ReportsAnalytics from './ReportsAnalytics';
import AnalyticsHorizontalTab from './AnalyticsHorizontalTab';
import { adminAnalyticsPanelItems, ANALYTICSCASEHORIZONTALTAB, ANALYTICSCLIENTHORIZONTALTAB, ANALYTICSHORIZONTALTAB, ANALYTICSPROFHORIZONTALTAB } from 'Constants';
import AnalyticsCases from './AnalyticsCases';
import AnalyticsProfessional from './AnalyticsProfessional';
import AnalyticsPageViews from './AnalyticsPageViews';
import AnalyticsClient from './AnalyticsClient';
import useIsMobile from 'Hooks/useIsMobile';
import SidePanelMobile from 'Components/Professional/Cases/SidePanelMobile';
import HeaderMenuItems from 'Components/Header/HeaderMenuItems';
import { Menu } from 'lucide-react';

function AnalyticsPanelRedirect({activePanel, setActivePanel}) {
  const [openMenu, setOpenMenu] = useState(false);
  const isMobile = useIsMobile();
  const [, setSearchParams] = useSearchParams();
  const prevPanel = useRef(activePanel);

  // Each sidebar section opens on its analytics view; ?view=/filters belong to the section you left
  useEffect(() => {
    if (prevPanel.current !== activePanel) {
      prevPanel.current = activePanel;
      setSearchParams({}, { replace: true });
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePanel]);

  const builder = (activePanel) => {
    switch(activePanel)
    {
      case 0 :
        return <AnalyticsCases setActivePanel={setActivePanel} activePanel={activePanel} />
      case 1 : 
        return <AnalyticsProfessional setActivePanel={setActivePanel} activePanel={activePanel} />
      case 2:
        return <AnalyticsClient setActivePanel={setActivePanel} activePanel={activePanel} />
      case 3:
        return <UserLoginActivity  setActivePanel={setActivePanel} activePanel={activePanel} />
      case 4: 
        return <ReportsAnalytics setActivePanel={setActivePanel} activePanel={activePanel} />
      case 5:
        return <AnalyticsPageViews setActivePanel={setActivePanel} activePanel={activePanel} />
      default:
        <></>
    }
  }
  return (
    <div className=' w-full '>
      {builder(activePanel)}
    </div>
  )
}

export default AnalyticsPanelRedirect;